// @core/api/endpoints/resource/unlink_resources.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/resource';

/**
 * Unlink two resources
 * Removes a directed link between a source and target resource. Publishes a resource.unlinked Kafka event.
 */
export async function UnlinkResources(
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/resources/links`;
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
